// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyA-3ITDie_P0ES48bXHvxnaJJk8k2CF2zg",
    authDomain: "western-express-d2d91.firebaseapp.com",
    projectId: "western-express-d2d91",
    storageBucket: "western-express-d2d91.appspot.com",
    messagingSenderId: "745883610572",
    appId: "1:745883610572:web:4fcd7c5e0ab22026c5c169"
};

export default firebaseConfig;